import { getAnalytics } from '@dcl/ui';
import rehydrators from './rehydrators';

const gtm = getAnalytics('gtm');
const consoleAnalytics = getAnalytics('console');

const analytics = (...args) => {
  gtm(...args);

  // @ts-ignore
  if (window.emcmUiEnableConsole) {
    consoleAnalytics(...args);
  }
};

const options = {
  extra: {
    analytics,
    rehydrators,
  },
};

export default options;
export { rehydrators, options };
